import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

interface MenuTextProps {
  color: string;
}

export const MenuItemContainer = styled(MenuItem)(() => ({
  display: "flex",
  alignItems: "center",
}));

export const MenuText = styled("div")(({ color }: MenuTextProps) => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  color,
}));
